import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { SupabaseUserToolsService } from '../shared/services/supabase-user-tools.service';
import { ClubService } from '../shared/services/club.service';

@Injectable({
  providedIn: 'root',
})
export class IsVerifiedGuard implements CanActivate {
  constructor(
    private supabaseUserToolService: SupabaseUserToolsService,
    private clubService: ClubService,
    private router: Router
  ) {}
  async canActivate() {
    const state = await this.supabaseUserToolService.getApprovalState();

    if (state === 'approved') {
      return true;
    }

    // Indeterminate (no session/clubId yet, RPC error) must NOT trap an
    // already-approved user on the pending screen — that was the prod bug.
    // Let navigation proceed; RLS and the booking RPCs still enforce real
    // access. Only a CONFIRMED not-approved is gated below.
    if (state === 'unknown') {
      return true;
    }

    // state === 'not_approved' — genuine pending/rejected member.
    const isRejected = await this.supabaseUserToolService.isUserRejected();
    if (isRejected) {
      return this.router.navigate(['404']);
    }
    // When the club REQUIRES verification documents, route unapproved
    // members to the submission page instead of the generic pending
    // screen. Same is_approved gate — an admin still approves manually,
    // after which this guard passes normally. Gated on the admin
    // member-requirement toggle AND the feature flag (the feature flag stays
    // a clean kill-switch) — NOT on the feature flag alone, which only
    // controls whether the admin can reach the management page.
    const flags = this.clubService.flags();
    if (flags?.verification_documents && flags?.verification_documents_required) {
      return this.router.navigate(['verification-documents']);
    }
    return this.router.navigate(['pendingVerification']);
  }
}
